import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-gestao-funcionarios',
  template: `
  <router-outlet></router-outlet>
`,
})
export class GestaoFuncionariosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
